import React, { useState } from 'react';
import { Card, Grid, Typography, Button } from '@material-ui/core';
import { Plus } from 'react-feather';
import {
  GQLDeliveryUnit,
  GQLDeliveryUnitPieceInventoryStats,
  GQLParty
} from '@jewelutions/core-crm-server-api-client-domain';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

interface IProps {
  party: GQLParty;
  pieceId: string;
  deliveryUnit: GQLDeliveryUnit;
}

const PieceInventoryStatsWidget: React.FC<IProps> = ({ party, pieceId, deliveryUnit }: IProps) => {
  const [stats, setStats] = useState((undefined as unknown) as GQLDeliveryUnitPieceInventoryStats);
  GQLOperationBuilder.deliveryUnit.getDeliveryUnitPieceInventoryStats(
    { producerPartyId: party.id, deliveryUnitId: deliveryUnit.id, pieceId: pieceId },
    {
      onCompleted: (data: any) => {
        setStats(GQLOperationBuilder.deliveryUnit.pieceInventoryStatsFromResponse(data));
      }
    }
  );

  const [updateMissingPieceInventories] = GQLOperationBuilder.deliveryUnit.createMissingPieceInventorys();
  return (
    <Grid container direction="row">
      <Grid item md={4} style={{ marginBottom: '8px' }}>
        <Card style={{ padding: '8px' }}>
          <Typography variant={'h6'}>{deliveryUnit.name}</Typography>
          <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
            <span>
              Piece inventories{' '}
              <strong>
                {stats?.existingPieceInventoryCount}/{stats?.maximumPieceInventoryCount}
              </strong>
            </span>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              disabled={stats?.existingPieceInventoryCount === stats?.maximumPieceInventoryCount}
              onClick={() => {
                updateMissingPieceInventories({
                  variables: { partyId: party.id, deliveryUnitId: deliveryUnit.id, pieceId: pieceId }
                });
              }}
            >
              <Plus />
              <span style={{ marginLeft: '4px' }}>Add all missing</span>
            </Button>
          </div>
        </Card>
      </Grid>
    </Grid>
  );
};

export default PieceInventoryStatsWidget;
